import React from "react";
import { RouteComponentProps } from "@reach/router";

interface Props extends RouteComponentProps {}

const NotValid = (props: Props) => <h1>Redirect URI is not valid</h1>;

export default NotValid;
